import { useObservable } from "micro-observables";
import { useEffect, useRef } from "react";
import { useServices } from "@core/servicesContext";

export function useNewContentUpdate(): boolean {
	const { postService } = useServices();
	const timeout = useRef<NodeJS.Timeout>(null);

	useEffect(() => {
		const run = async (): Promise<void> => {
			timeout.current = setTimeout(async () => {
				await postService.checkNewContent();
				await run();
			}, 60 * 1000);
		};
		void run();
		return () => {
			if (timeout.current) clearTimeout(timeout.current);
		};
	}, []);

	return useObservable(postService.hasNewContent);
}
